import React from 'react';

const PostImage = () => {
  return ( <div className = "post-image"></div> );
}

export default PostImage;
